module.exports = __webpack_public_path__ + "img/88.6.CODm.0fb81da4.png";